const SKILL_LEVEL = {
  beginner: 1,
  intermediate: 2,
  advanced: 3,
  expert: 4,
};

export default SKILL_LEVEL;
